import React, { useState } from "react";

import "./UploadDataContents.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { UploadDataForm } from "./UploadDataForm";
import EmptyPage from "components/general/EmptyPage";

import { additionalNote } from "./upload_config/additionalNoteUploadConfig";
import { ftCostPDFUploadConfig } from "./upload_config/ftCostPDFUploadConfig";
import { calendarCSVUploadConfig } from "./upload_config/calendarCSVUploadConfig";
import { dailyUpdateCSVUploadConfig } from "./upload_config/dailyUpdateCSVUploadConfig";
import { updateIrradianceCSVUploadConfig } from "./upload_config/updateIrradianceCSVUploadConfig";
import { updateIndexesCSVUploadConfig } from "./upload_config/updateIndexesCSVUploadConfig";
import { envisionReinsertCSVUploadConfig } from "./upload_config/envisionReinsertCSVUploadConfig";
import { useUser } from "util/user";

const selectStyle = {
	container: (provided) => ({
		...provided,
		fontSize: "1.5rem !important",
		width: "300px",
		float: "none !important",
		display: "inline-block !important",
	}),
	control: (provided) => ({
		...provided,
		paddingLeft: "10px",
	}),
	valueContainer: () => ({
		display: "flex",
		flex: "1 1 0%",
		flexWrap: "wrap",
		overflowY: "auto",
		color: "black",
	}),
	menu: (provided) => ({
		...provided,
		color: "#000",
		backgroundColor: "#fff",
	}),
};

export const UploadDataContents = () => {
	const user = useUser();
	const [selectedOption, setSelectedOption] = useState(null);

	const visibilityRoles = {
		additionalNote: [["_GY:O&M"], ["_GY:IT"]],
		ftCostPDFUploadConfig: [["_GY:O&M", "_GY:TH"], ["_GY:IT"]],
		calendarCSVUploadConfig: [["_GY:O&M", "_GY:TH"], ["_GY:IT"]],
		dailyUpdateCSVUploadConfig: [["_GY:O&M"], ["_GY:IT"]],
		updateIrradianceCSVUploadConfig: [["_GY:O&M"], ["_GY:IT"]],
		updateIndexesCSVUploadConfig: [["_GY:O&M"], ["_GY:IT"]],
		envisionReinsertCSVUploadConfig: [["_GY:O&M"], ["_GY:IT"]],
	};

	const uploadDataOptions = [
		{ value: "additionalNote", label: "Additional Note For Invoice", visibility: visibilityRoles.additionalNote },
		{ value: "ftCostPDFUploadConfig", label: "FT Cost PDF Upload", visibility: visibilityRoles.ftCostPDFUploadConfig },
		{ value: "calendarCSVUploadConfig", label: "Calendar CSV Upload", visibility: visibilityRoles.calendarCSVUploadConfig },
		{ value: "dailyUpdateCSVUploadConfig", label: "Daily Solar ON/OFF Modification", visibility: visibilityRoles.dailyUpdateCSVUploadConfig },
		{ value: "updateIrradianceCSVUploadConfig", label: "Irradiance Range Upload", visibility: visibilityRoles.updateIrradianceCSVUploadConfig },
		{ value: "updateIndexesCSVUploadConfig", label: "Monthly Indexes Upload", visibility: visibilityRoles.updateIndexesCSVUploadConfig },
		{ value: "envisionReinsertCSVUploadConfig", label: "Daily Data Reinsertion Upload", visibility: visibilityRoles.envisionReinsertCSVUploadConfig },
	];
	const uploadDataAvaiOptions = uploadDataOptions.filter((option) => {
		const roles = option.visibility;
		return roles.some(roleGroup => roleGroup.every(role => user.roles.includes(role)));
	});

	const onChangeOption = (option) => {
		setSelectedOption(option && option.value ? option.value : null);
	};

	const uploadConf = {
		additionalNote,
		ftCostPDFUploadConfig,
		calendarCSVUploadConfig,
		dailyUpdateCSVUploadConfig,
		updateIrradianceCSVUploadConfig,
		updateIndexesCSVUploadConfig,
		envisionReinsertCSVUploadConfig,
	};

	return (
		<div id="dataupload">
			<div className="panel-heading main-color-bg">
				<h3 className="panel-title headerUpload">
					<div>
						<span className="glyphicon glyphicon-cog" aria-hidden="true"></span>{" "}
						UPLOAD DATA OF{" "}
					</div>
					{uploadDataAvaiOptions.length !== 0 && (
						<Select
							options={uploadDataAvaiOptions}
							placeholder="Search to Select"
							onChange={onChangeOption}
							styles={selectStyle}
						/>
					)}
				</h3>
			</div>
			{/* Content Start Here */}
			{!selectedOption && (
				<EmptyPage message={"No upload data option selected"} />
			)}
			{!!selectedOption && (
				<UploadDataForm
					modalTitle={uploadConf[selectedOption].modal.title}
					modalContent={uploadConf[selectedOption].modal.content}
					formTitle={uploadConf[selectedOption].form.title}
					formDescription={uploadConf[selectedOption].form.description}
					formUploadUrl={uploadConf[selectedOption].form.upload.uploadUrl}
					formUploadMaxCount={uploadConf[selectedOption].form.upload.maxCount}
					formUploadAccept={uploadConf[selectedOption].form.upload.accept}
					formUploadIsInvalid={uploadConf[selectedOption].form.upload.isInvalid}
				/>
			)}
		</div>
	);
};
